import StoreSettingsPage from './detail/StoreSettingsPage';
import DefaultsTab from './detail/DefaultsTab';

export default function StoreErp() {
	return (
		<StoreSettingsPage title='Store - ERP'>
			{(store, setStore) => <DefaultsTab store={store} onUpdated={setStore} />}
		</StoreSettingsPage>
	);
}
